import React from 'react';
import {
  Crop1,
  Crop2,
  Crop3,
  Crop4,
  Crop5,
  Crop6,
  Crop7,
  Crop8,
  Crop9,
  Crop10,
  Crop11,
  Crop12,
  Crop13,
  Crop14,
  Crop15,
  Crop16,
  Crop17,
  Crop18,
  Crop19,
  Crop20,
  Crop21,
  Crop22,
  Crop23,
  Crop24,
  Crop25,
  Crop26,
  Crop27,
  Crop28,
  Crop29,
  Crop30,
  Crop31,
  Crop32,
  Crop33,
  Crop34,
  Crop35,
  Crop36,
  Crop37,
  Crop38,
  Crop39,
  Crop40,
  Crop41,
  Crop42,
  Crop43,
  Crop44,
  Crop45,
  Crop46,
  Crop47,
  Crop48,
  Crop49,
  Crop50,
  CropLp1,
  CropLp3,
  GradientCrop1,
  GradientCrop2,
  GradientCrop3,
  GradientCrop4,
  GradientCrop5,
  GradientCrop6,
  GradientCrop7,
  GradientCrop8,
  GradientCrop9,
  GradientCrop13,
  GradientCrop14,
  GradientCrop15,
  GradientCrop16,
  GradientCrop17,
  GradientCrop18,
  GradientCrop19,
  GradientCrop20,
  GradientCrop21,
  GradientCrop22,
  GradientCrop23,
  GradientCrop24,
  GradientCrop25,
  GradientCrop26,
  GradientCrop27,
  GradientCrop28,
  GradientCrop29,
  GradientCrop30,
  GradientCrop31,
  GradientCrop32,
  GradientCrop33,
  GradientCrop34,
  GradientCrop35,
  GradientCrop36,
  GradientCrop37,
  GradientCrop38,
  GradientCrop39,
  GradientCrop40,
  GradientCrop41,
  GradientCrop42,
  GradientCrop43,
  GradientCrop44,
  GradientCrop45,
  GradientCrop46,
  GradientCrop47,
  GradientCrop48,
  GradientCrop49,
  GradientCrop50,
} from 'components/Icons';
import Product from 'components/Icons/Product';

const gradientCrops = {
  1: GradientCrop1,
  2: GradientCrop2,
  3: GradientCrop3,
  4: GradientCrop4,
  5: GradientCrop5,
  6: GradientCrop6,
  7: GradientCrop7,
  8: GradientCrop8,
  9: GradientCrop9,
  13: GradientCrop13,
  14: GradientCrop14,
  15: GradientCrop15,
  16: GradientCrop16,
  17: GradientCrop17,
  18: GradientCrop18,
  19: GradientCrop19,
  20: GradientCrop20,
  21: GradientCrop21,
  22: GradientCrop22,
  23: GradientCrop23,
  24: GradientCrop24,
  25: GradientCrop25,
  26: GradientCrop26,
  27: GradientCrop27,
  28: GradientCrop28,
  29: GradientCrop29,
  30: GradientCrop30,
  31: GradientCrop31,
  32: GradientCrop32,
  33: GradientCrop33,
  34: GradientCrop34,
  35: GradientCrop35,
  36: GradientCrop36,
  37: GradientCrop37,
  38: GradientCrop38,
  39: GradientCrop39,
  40: GradientCrop40,
  41: GradientCrop41,
  42: GradientCrop42,
  43: GradientCrop43,
  44: GradientCrop44,
  45: GradientCrop45,
  46: GradientCrop46,
  47: GradientCrop47,
  48: GradientCrop48,
  49: GradientCrop49,
  50: GradientCrop50,
};

const crops = {
  1: Crop1,
  2: Crop2,
  3: Crop3,
  4: Crop4,
  5: Crop5,
  6: Crop6,
  7: Crop7,
  8: Crop8,
  9: Crop9,
  10: Crop10,
  11: Crop11,
  12: Crop12,
  13: Crop13,
  14: Crop14,
  15: Crop15,
  16: Crop16,
  17: Crop17,
  18: Crop18,
  19: Crop19,
  20: Crop20,
  21: Crop21,
  22: Crop22,
  23: Crop23,
  24: Crop24,
  25: Crop25,
  26: Crop26,
  27: Crop27,
  28: Crop28,
  29: Crop29,
  30: Crop30,
  31: Crop31,
  32: Crop32,
  33: Crop33,
  34: Crop34,
  35: Crop35,
  36: Crop36,
  37: Crop37,
  38: Crop38,
  39: Crop39,
  40: Crop40,
  41: Crop41,
  42: Crop42,
  43: Crop43,
  44: Crop44,
  45: Crop45,
  46: Crop46,
  47: Crop47,
  48: Crop48,
  49: Crop49,
  50: Crop50,
  Lp1: CropLp1,
  Lp3: CropLp3,
};

export const cropPictoForID = (id, props, color) => {
  const Crop = crops[id];
  if (id === 'product') {
    return <Product {...props} color={color} />;
  }
  if (Crop === undefined) {
    return null;
  }
  return <Crop {...props} fill={color} />;
};

export const getGradientCropIcon = (id, props, plain) => {
  const GradientCrop = gradientCrops[id];
  if (GradientCrop === undefined) return null;
  if (plain) return GradientCrop;
  return <GradientCrop {...props} />;
};
